import FormItemData from "@/components/antd/form";
import {ACTION_METHOD_OBJ} from "@/constants";
import {layout} from "@/constants/layout";
import {API} from "@/network/http";
import {BaseUpsertFormProps} from "@/typing/common";
import {Button, Card, Form, Modal, Row} from "antd";
import React, {forwardRef, useEffect, useImperativeHandle} from "react";

const UpsertForm: React.FC<BaseUpsertFormProps> = forwardRef((props, ref) => {
  const {modalVisible, onCancel, onSubmit, actionType, values, loadingBtn} = props;
  const [form] = Form.useForm();

  // as the second argument
  useImperativeHandle(ref, () => ({
    onResetData() {
      // reset sale table
      form.resetFields();
    },
  }));

  const getListEmployee = async (searchValue?: string) => {
    const response = await API.employees.employeeControllerGetMany({name: searchValue});
    return (
      response?.data?.data?.map((item: any) => ({
        value: item._id,
        key: item._id,
        name: item.name,
      })) || []
    );
  };

  const getListDepartment = async (searchValue?: string) => {
    const response = await API.departments.departmentControllerGetMany({name: searchValue});
    return (
      response?.data?.data?.map((item: any) => ({
        value: item._id,
        key: item._id,
        name: item.name,
      })) || []
    );
  };

  useEffect(() => {
    if (actionType === "UPDATE") {
      form.setFieldsValue({
        name: values?.name,
        parentDepartmentId: values?.parentDepartmentId,
        employeeIdManagement: values?.employeeIdManagement,
        isSpecialize: values?.isSpecialize,
        isDefault: values?.isDefault,
        isOperator: values?.isOperator,
      });
    }
  }, []);

  const handleSubmit = async () => {
    const fieldsValidation = await form.validateFields();
    if (!fieldsValidation) {
      return;
    }
    const formValues = {...form.getFieldsValue()};
    if (actionType === "CREATE") {
      onSubmit(formValues, actionType);
    }
    if (actionType === "UPDATE") {
      onSubmit(formValues, actionType, values._id);
    }
  };

  const onResetForm = (): void => {
    // reset sale table
    form.resetFields();
  };

  const renderContentList = [
    {
      inputType: "input",
      name: "name",
      label: "Tên phòng ban",
      placeholder: "Nhập tên phòng ban",
      rules: [{required: true, message: "Nhập tên phòng ban"}],
    },
    {
      inputType: "selectsearch",
      name: "parentDepartmentId",
      label: "Thuộc phòng ban cấp trên",
      placeholder: "Chọn phòng ban cấp trên",
      fetchOptions: getListDepartment,
    },
    {
      inputType: "selectsearch",
      name: "employeeIdManagement",
      label: "Nhân viên quản lý",
      placeholder: "Chọn nhân viên quản lý",
      fetchOptions: getListEmployee,
      rules: [{message: "Chọn nhân viên quản lý"}],
    },
    {
      inputType: "checkbox",
      name: "isDefault",
      label: "Là phòng ban cơ bản",
    },
    {
      inputType: "checkbox",
      name: "isSpecialize",
      label: "Là phòng ban chuyên môn",
    },
    {
      inputType: "checkbox",
      name: "isOperator",
      label: "Là phòng ban vận hành",
    },
  ];

  const renderContent = () => {
    return (
      <Card style={{paddingRight: "20px"}}>
        <Row gutter={24}>{renderContentList.map(item => item && <FormItemData key={item.name} {...item} />)}</Row>
      </Card>
    );
  };

  const renderFooter = () => {
    return (
      <>
        {props.actionType === "CREATE" && <Button onClick={() => onResetForm()}>Làm mới</Button>}
        <Button loading={loadingBtn} type="primary" onClick={handleSubmit}>
          Đồng ý
        </Button>
      </>
    );
  };

  return (
    <>
      <Modal
        bodyStyle={{background: "#F0F2F5"}}
        width={700}
        destroyOnClose
        maskClosable={false}
        title={`${ACTION_METHOD_OBJ[actionType]} phòng ban`}
        visible={modalVisible}
        onCancel={() => {
          onResetForm();
          onCancel();
        }}
        footer={renderFooter()}
      >
        <Form {...layout} labelWrap form={form}>
          {renderContent()}
        </Form>
      </Modal>
    </>
  );
});

export default UpsertForm;
